const translation = {
    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',

    // CUSTOM TRANSLATIONS
    'i_agree_to_the': 'I agree to the',
}

export {translation};
